module.exports = __webpack_public_path__ + "img/HomepageBannerHeaderDark.fd6ea790.png";